import { useState } from "react";
import VimeoVideoPlayer from "./VimeoVideoPlayer";
import VimeoAudioPlayer from "./VimeoAudioPlayer";
import { Box } from "@mui/material";
import { generatePublicUrlForFileInAWSS3Bucket } from "../../../services/uploadFileOnAWS_S3_Bucket";

const ViemoPlayerWithMarker = ({ editableMultimediaData, setEditableMultimediaData, multimediaData, setMultimediaData, global_constant }) => {

    //console.log("editableMultimediaData : ", editableMultimediaData)
    //console.log("multimediaData : ", multimediaData)

    return (
        <>
            {/* <Box sx={styles.containerStyleRow_sx}> */}

            <Box sx={{ flex: 0, p: 2, display: "flex", height: 'auto', width: '100%', justifyContent: "center", alignItems: "flex-start" }}>
                {multimediaData?.form === "video" && (
                    <VimeoVideoPlayer
                        multimediaData={multimediaData}
                    />
                )}
                {multimediaData?.form === "audio" && (
                    <VimeoAudioPlayer
                        multimediaData={multimediaData}
                    />
                )}
                {multimediaData?.form === "image" && (
                    <div
                        style={{
                            position: "relative",
                            height: "400px",
                            width: "400px",
                            margin: "auto",
                            background: "lightgray",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #000000",
                            borderRadius: 4,
                            overflow: "hidden",
                        }}
                    >
                        <img
                            src={generatePublicUrlForFileInAWSS3Bucket(multimediaData?.url)}
                            alt="media"
                            style={{
                                width: "auto",
                                height: "100%",
                                objectFit: "contain"
                            }}
                        />
                    </div>
                )}
            </Box>

            {/* </Box> */}
        </>
    );
};

const styles = {
    containerStyleRow_sx: {
        backgroundColor: 'red',
        justifyContent: 'flex-start',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 0,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 0,
        height: "100%",
        alignItems: "center",
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default ViemoPlayerWithMarker;
